// src/components/Whitepaper.js
import colors from '../colors';
import React, { useState } from 'react';

function Whitepaper() {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <section id="whitepaper" style={styles.section}>
            <div style={styles.container}>
                <h2
                    style={styles.heading}
                    onClick={toggleExpansion}
                    aria-expanded={isExpanded}
                    role="button">
                    Whitepaper {isExpanded ? '▲' : '▼'}
                </h2>
                {isExpanded && (
                    <div style={styles.content}>
                        {/* Abstract */}
                        <h3 style={styles.subheading}>Abstract</h3>
                        <p style={styles.paragraph}>
                            Wisemoji is a revolutionary meme coin that merges ancient wisdom with modern digital culture. By transforming the profound sayings of Confucius and Buddha into viral memes, Wisemoji aims to create a community that appreciates both humor and enlightenment. This whitepaper outlines the vision, mission, and roadmap for Wisemoji.
                        </p>

                        {/* Introduction */}
                        <h3 style={styles.subheading}>Introduction</h3>
                        <p style={styles.paragraph}>
                            In a world dominated by fleeting digital trends, Wisemoji seeks to anchor viral content with timeless wisdom. We believe that memes are not just for entertainment but can also be vehicles for sharing valuable life lessons. By blending the depth of ancient teachings with the accessibility of internet culture, Wisemoji aspires to create a unique and engaging platform.
                        </p>

                        {/* Vision */}
                        <h3 style={styles.subheading}>Vision</h3>
                        <p style={styles.paragraph}>
                            To become the leading meme coin that not only entertains but also enlightens, fostering a global community that values wisdom wrapped in humor.
                        </p>

                        {/* Mission */}
                        <h3 style={styles.subheading}>Mission</h3>
                        <ul style={styles.list}>
                            <li>Bridge Ancient Wisdom and Modern Memes: Transform profound quotes into relatable and shareable memes.</li>
                            <li>Community Engagement: Build a vibrant community that contributes to the creation and dissemination of Wisemoji memes.</li>
                            <li>Charitable Initiatives: Support educational programs and initiatives that promote wisdom and learning.</li>
                        </ul>

                        {/* Key Features */}
                        <h3 style={styles.subheading}>Key Features</h3>
                        <ul style={styles.list}>
                            <li>Meme-ified Wisdom: Regular releases of memes that put a humorous spin on ancient sayings.</li>
                            <li>Community-Driven Content: Allow community members to submit and vote on new meme ideas.</li>
                            <li>Rewards System: Incentivize active participants with Wisemoji tokens.</li>
                        </ul>

                        {/* Roadmap */}
                        <h3 style={styles.subheading}>Roadmap</h3>
                        <ol style={styles.list}>
                            <li>
                                <strong>Phase 1: Launch</strong>
                                <ul>
                                    <li>Website and social media launch.</li>
                                    <li>Initial distribution of Wisemoji tokens.</li>
                                    <li>Community building and engagement.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Phase 2: Platform Development</strong>
                                <ul>
                                    <li>Develop a platform for users to submit and vote on memes.</li>
                                    <li>Implement a rewards system for content creators.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Phase 3: Expansion</strong>
                                <ul>
                                    <li>Partnerships with educational and charitable organizations.</li>
                                    <li>Launch of merchandise and NFT collections.</li>
                                    <li>Global marketing campaigns.</li>
                                </ul>
                            </li>
                        </ol>

                        {/* Token Distribution */}
                        <h3 style={styles.subheading}>Token Distribution</h3>
                        <p style={styles.paragraph}>
                            <strong>Total Supply:</strong> 1,000,000,000 WISEMOJI
                        </p>
                        <p style={styles.paragraph}>
                            <strong>Allocation:</strong>
                        </p>
                        <ul style={styles.list}>
                            <li><strong>Burned:</strong> 80%</li>
                            <li><strong>Development Team:</strong> 10%</li>
                            <li><strong>Liquidity Listing:</strong> 10%</li>
                        </ul>

                        {/* Community and Governance */}
                        <h3 style={styles.subheading}>Community and Governance</h3>
                        <p style={styles.paragraph}>
                            Wisemoji is a community-driven project. Holders of WISEMOJI tokens will have voting rights on key decisions, including future developments, partnerships, and charitable initiatives.
                        </p>

                        {/* Conclusion */}
                        <h3 style={styles.subheading}>Conclusion</h3>
                        <p style={styles.paragraph}>
                            Wisemoji aims to redefine the meme coin landscape by adding depth and purpose to viral content. Join us on this journey to spread wisdom through memes and create a community that values both laughter and learning.
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}

const styles = {
    section: {
        backgroundColor: colors.primaryDark,
        padding: '20px 0',
    },
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 20px',
    },
    heading: {
        color: colors.textLight,
        fontSize: '1.8rem',
        marginBottom: '20px',
        cursor: 'pointer',
        textAlign: 'center',
    },
    content: {
        textAlign: 'center',
        // Optional: add transition effects if desired
    },
    subheading: {
        color: colors.textLight,
        fontSize: '1.5rem',
        marginTop: '30px',
    },
    paragraph: {
        color: colors.textLight,
        fontSize: '1rem',
        lineHeight: '1.6',
        marginTop: '15px',
        textAlign: 'left',
    },

    list: {
        color: colors.textLight,
        fontSize: '1rem',
        lineHeight: '1.6',
        marginTop: '15px',
        paddingLeft: '50px',
        textAlign: 'left',
    },
};

export default Whitepaper;